import GramSet from './GramSet'
import Location from './Location'

export default GramSet
export { Location }
